import { AppDatePicker } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';

export default function Report57Options({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  values,
}) {
  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-intelligence"
                name="from"
              />
            }
            value={values.from}
            onChange={(date) => handleOnSetFieldValue('from', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-intelligence"
                name="to"
              />
            }
            value={values.to}
            onChange={(date) => handleOnSetFieldValue('to', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
}
